export default "__VITE_ASSET__BZJ$5qcu__"